import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/learn-articles/")({
  // Legacy section from the previous site.
  loader: () => {
    throw redirect({ to: "/learn", statusCode: 301 });
  },
});
